import React from 'react';
import SubscriptionPricingCards from '../components/PlanCards';

export const SubscriptionPlans = () => {
  return (
    <>
      <div style={{ textAlign: 'center', marginTop: '1rem' }}>
        <h1 className='mt-0'>Subscription Plans</h1>
        <p>This is the subscription plans page.</p>
        <div className='p-3'><SubscriptionPricingCards /></div>
      </div>
    </>
  );
};

